import { render, staticRenderFns } from "./SiteSetting.vue?vue&type=template&id=563eb93a&scoped=true&"
import script from "./SiteSetting.vue?vue&type=script&lang=js&"
export * from "./SiteSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563eb93a",
  null
  
)

export default component.exports